import {
  IPlaningCycle,
  IPlanningControlData,
  IPlanningJourneyStep,
  IPlanningReadiness,
  IPlanningRecommendation,
  JsonObject,
} from './planningcontrol.models';

import { json, postBiz, rows } from '../core/coreapi';
//import { IBiePlanningContext } from '../bieprofile/bieprofile.models';

const SERVICE = 'bieplanningcontrol';

// export async function fetchBiePlanningContext(): Promise<IBiePlanningContext> {
//   const response = await postBiz({
//     s: SERVICE,
//     a: 'getcontext',
//   });
//   return json(response);
// }

// export async function setBiePlanningCycle(
//   planningCycleId: number,
// ): Promise<IBiePlanningContext> {
//   const response = await postBiz({
//     s: SERVICE,
//     a: 'setplanningcycle',
//     pci: planningCycleId,
//   });
//   return json(response);
// }


// paramsrecommend: ':pci,:reg',
//   paramsapplyrecommendation: ':rci,:acc,:apv',
//     paramsupdatepolicy: ':rid',
//       paramsgetjourney: ':pci,:reg',
//         paramsgetreadiness: ':pci',
//           paramsget: ':pci',
//             paramsopencycle: ':pci,:aic',




// interface IServiceLike {
//   send?: (request: JsonObject) => Promise<unknown>;
//   post?: (url: string, payload: JsonObject) => Promise<unknown>;
// }

// interface IEnvelope<T> {
//   rc: number;
//   sd: T;
// }

// function unwrap<T>(value: unknown): T {
//   const response = value as
//     | IEnvelope<T>
//     | { data?: IEnvelope<T> | T }
//     | T;

//   if (
//     response &&
//     typeof response === 'object' &&
//     'data' in response &&
//     response.data !== undefined
//   ) {
//     return unwrap<T>(response.data);
//   }

//   if (
//     response &&
//     typeof response === 'object' &&
//     'sd' in response
//   ) {
//     return (response as IEnvelope<T>).sd;
//   }

//   return response as T;
// }

// async function execute<T>(
//   service: unknown,
//   functionName: string,
//   params: JsonObject,
// ): Promise<T> {
//   const client = service as IServiceLike;
//   const payload = {
//     function: functionName,
//     params,
//   };

//   if (typeof client?.send === 'function') {
//     return unwrap<T>(await client.send(payload));
//   }

//   if (typeof client?.post === 'function') {
//     return unwrap<T>(await client.post('/api/function', payload));
//   }

//   throw new Error(
//     'The supplied service does not expose send(...) or post(...). ' +
//       'Adapt execute(...) to the BPMMS service wrapper.',
//   );
// }

// export function fetchPlanningControl(
//   service: unknown,
//   planningCycleId: number,
//   userId: number,
// ): Promise<IPlanningControlData> {
//   return execute<IPlanningControlData>(
//     service,
//     'bie.spx_bieplanningcontrol_get',
//     {
//       p_planningcycleid: planningCycleId,
//       p_userid: userId,
//     },
//   );
// }

export async function fetchPlanningControl(
  planningCycleId: number,
): Promise<IPlanningControlData> {
  const response = await postBiz({
    s: SERVICE,
    a: 'get',
    pci: planningCycleId,
  });
  return json(response);
}

// export function generatePlanningRecommendations(
//   service: unknown,
//   planningCycleId: number,
//   regenerate: boolean,
//   userId: number,
// ): Promise<IPlanningRecommendation[]> {
//   return execute<IPlanningRecommendation[]>(
//     service,
//     'bie.spx_bieplanningcontrol_recommend',
//     {
//       p_planningcycleid: planningCycleId,
//       p_regenerate: regenerate ? 1 : 0,
//       p_userid: userId,
//     },
//   );
// }

export async function generatePlanningRecommendations(
  planningCycleId: number,
  regenerate: boolean,
): Promise<IPlanningRecommendation[]> {
  const response = await postBiz({
    s: SERVICE,
    a: 'recommend',
    pci: planningCycleId,
    reg: regenerate ? 1 : 0,
  });
  return rows(response);
}

// export function applyPlanningRecommendation(
//   service: unknown,
//   recommendationId: number,
//   actionCode: 'ACCEPTED' | 'MODIFIED' | 'IGNORED',
//   appliedValue: JsonObject | null,
//   userId: number,
// ): Promise<IPlanningRecommendation> {
//   return execute<IPlanningRecommendation>(
//     service,
//     'bie.spx_bieplanningcontrol_applyrecommendation',
//     {
//       p_recommendationid: recommendationId,
//       p_actioncode: actionCode,
//       p_appliedvalue: appliedValue,
//       p_userid: userId,
//     },
//   );
// }

export async function applyPlanningRecommendation(
  recommendationId: number,
  actionCode: 'ACCEPTED' | 'MODIFIED' | 'IGNORED',
  appliedValue: JsonObject | null,
): Promise<IPlanningRecommendation> {
  const response = await postBiz({
    s: SERVICE,
    a: 'applyrecommendation',
    rci: recommendationId,
    acc: actionCode,
    apv: appliedValue,
  });
  return json(response);
}

// export function confirmAllPlanningScopes(
//   service: unknown,
//   planningCycleId: number,
//   userId: number,
// ): Promise<unknown> {
//   return execute<unknown>(
//     service,
//     'bie.spx_bieplanningscope_confirmall',
//     {
//       p_planningcycleid: planningCycleId,
//       p_userid: userId,
//     },
//   );
// }

export async function confirmAllPlanningScopes(
  planningCycleId: number,
): Promise<any> {
  const response = await postBiz({
    s: 'bieplanningscope',
    a: 'confirmall',
    pci: planningCycleId,
  });
  return json(response);
}

// export function generatePlanningJourney(
//   service: unknown,
//   planningCycleId: number,
//   regenerate: boolean,
//   userId: number,
// ): Promise<IPlanningJourneyStep[]> {
//   return execute<IPlanningJourneyStep[]>(
//     service,
//     'bie.spx_bieplanningcontrol_getjourney',
//     {
//       p_planningcycleid: planningCycleId,
//       p_regenerate: regenerate ? 1 : 0,
//       p_userid: userId,
//     },
//   );
// }

export async function generatePlanningJourney(
  planningCycleId: number,
  regenerate: boolean,
): Promise<IPlanningJourneyStep[]> {
  const response = await postBiz({
    s: SERVICE,
    a: 'getjourney',
    pci: planningCycleId,
    reg: regenerate ? 1 : 0,
  });
  return rows(response);
}

// export function fetchPlanningReadiness(
//   service: unknown,
//   planningCycleId: number,
//   userId: number,
// ): Promise<IPlanningReadiness> {
//   return execute<IPlanningReadiness>(
//     service,
//     'bie.spx_bieplanningcontrol_getreadiness',
//     {
//       p_planningcycleid: planningCycleId,
//       p_userid: userId,
//     },
//   );
// }

export async function fetchPlanningReadiness(
  planningCycleId: number,
): Promise<IPlanningReadiness> {
  const response = await postBiz({
    s: SERVICE,
    a: 'getreadiness',
    pci: planningCycleId,
  });
  return json(response);
}

// export function openPlanningCycle(
//   service: unknown,
//   planningCycleId: number,
//   allowIncomplete: boolean,
//   userId: number,
// ): Promise<{
//   context: Record<string, unknown>;
//   readiness: IPlanningReadiness;
//   openedIncomplete: number;
// }> {
//   return execute(
//     service,
//     'bie.spx_bieplanningcontrol_opencycle',
//     {
//       p_planningcycleid: planningCycleId,
//       p_allowincomplete: allowIncomplete ? 1 : 0,
//       p_userid: userId,
//     },
//   );
// }

export async function openPlanningCycle(
  planningCycleId: number,
  allowIncomplete: boolean,
): Promise<IPlaningCycle> {
  const response = await postBiz({
    s: SERVICE,
    a: 'opencycle',
    pci: planningCycleId,
    aic: allowIncomplete ? 1 : 0,
  });
  return json(response);
}
